import React, { FC } from 'react';

import { generateRandomInt } from '../../../utils/number';
import SkeletonLine from '../SkeletonLine';

import * as Styled from './styled';

const sizeMin = 30;
const sizeMax = 70;

type Props = {
  nrItems?: number;
};

/**
 * Skeleton view for checklist items
 *
 * @param props         The props passed to the component
 * @param props.nrItems The number of checklist items to show the skeleton for
 * @returns             The component itself
 */
const SkeletonChecklist: FC<Props> = ({ nrItems = 2 }) => {
  // Generate random widths for skeleton lines, between sizeMin and sizeMax
  const widths = Array.from({ length: nrItems }, () => {
    return generateRandomInt(sizeMin, sizeMax);
  });

  return (
    <ul>
      {widths.map((width, index) => (
        // No way to generate a key for this
        // eslint-disable-next-line react/no-array-index-key
        <Styled.Li data-width={width} key={index}>
          <SkeletonLine />
        </Styled.Li>
      ))}
    </ul>
  );
};

export default SkeletonChecklist;
